import { computed, makeObservable } from 'mobx';

import { ISharedDataItem } from '@gem/models/sharedDataModel';

import { PayloadType, IOrderedItemMessagePayload } from 'APP/model/message/messageModel.types';
import { ArticlePayload } from 'STORE/Messages/Message/Payload/ArticlePayload/ArticlePayload';
import { AudioPayload } from 'STORE/Messages/Message/Payload/AudioPayload/AudioPayload';
import { SharedMessages } from 'STORE/SharedData/SharedMessages/SharedMessages';

import { SharedDataItem } from '../SharedDataItem/SharedDataItem';

type TSharedAudioItem = ISharedDataItem<AudioPayload>;

export class SharedAudio extends SharedDataItem {
  constructor(messages: SharedMessages) {
    super(messages);
    makeObservable(this);
  }

  @computed
  get items(): TSharedAudioItem[] {
    const items: TSharedAudioItem[] = [];
    const messages = this.messages.getFilteredMessages((message) =>
      [PayloadType.AudioMessage, PayloadType.Article].includes(message.payload.payloadType)
    );

    messages.forEach((message) => {
      if (message.payload instanceof ArticlePayload) {
        const payloads = message.payload.payloads.slice().reverse() as IOrderedItemMessagePayload[];

        payloads.forEach(({ id, payload }) => {
          if (payload instanceof AudioPayload) {
            items.push({
              id,
              messageId: message.id,
              groupId: message.groupId,
              payload,
              serverTime: message.serverTime,
            });
          }
        });
      } else {
        items.push({
          id: message.clientUuid,
          messageId: message.id,
          groupId: message.groupId,
          payload: message.payload,
          serverTime: message.serverTime,
        });
      }
    });

    return items;
  }

  @computed
  get count(): number {
    return this._count || this.items.length;
  }
}
